import $ from 'jquery';
import $hub from '../utility/events-hub';
import { getRequestVerificationToken } from '../utility/ajax-helpers';
import storeList from '../b2b/store-selector';
import lazyLoad from '../components/lazy-load';

const opts = {
    clickAndCollectContainer: '.js-click-and-collect-container',
    clickAndCollectTrigger: '.js-click-and-collect-store-choose',
    clickAndCollectTriggerSection: '.js-click-and-collect-section',
    cartOverviewContainer: '#js-cart-overview-container',
    cartSection: '#cartTable'

};

const changeDeliveryClickAndCollectStore = (e, options) => {

    const $btn = $(options.event.target);
    const store = $btn.data('store');

    const formData = {
        storeId: store
    };

    const $ccContainer = $(opts.clickAndCollectContainer);
    const $ccSection = $(opts.clickAndCollectTriggerSection);

    const $cartSection = $(opts.cartSection);
    const $overviewContainer = $(opts.cartOverviewContainer);

    $ccSection.addClass('loading');
    $cartSection.addClass('loading');
    $.fancybox.close();

    const params = {
        url: '/cart/setstore',
        type: 'POST',
        data: formData,
        headers: {
            ...getRequestVerificationToken
        }
    };

    $.ajax(params)
        .done(function (res) {

            if (res.IsSuccess) {
                $ccContainer.html(res.DeliveryView);
                $overviewContainer.html(res.CartOverView);
                lazyLoad.init();
            }
        }).always(() => {
            $ccSection.removeClass('loading');
            $cartSection.removeClass('loading');
        });
};

const init = () => {

    const $ccStoreSelectorTrigger = $(opts.clickAndCollectTrigger);

    if (!$ccStoreSelectorTrigger.length) { return; }

    if ($ccStoreSelectorTrigger.length) {
        storeList.init();

        $hub.subscribe($hub.event.storeSelected, changeDeliveryClickAndCollectStore);
    }
};

export default {
    init,
    changeDeliveryClickAndCollectStore
};
